import { Box } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { PATHS } from '../../router/routes';

const AdaptiveContainer = ({ children, title, ...props }) => {
    const calcWeight = useMemo(() => {
        if (title === PATHS.SIGN_IN || title === PATHS.SIGN_UP) {
            return { base: '327px', sm: '450px', md: '600px', lg: '620px', xl: '640px' };
        } else if (title === PATHS.FORGOT_PASSWORD || title === 'stepper' || title === PATHS.PHONE_PICK) {
            return { base: '327px', sm: '450px', md: '600px', lg: '620px', xl: '768px' };
        } else if (title === PATHS.VERIFICATION || title === PATHS.CHANGE_PASSWORD) {
            return { base: '327px', sm: '450px', md: '470px', lg: '520px', xl: '560px' };
        } else if (title === PATHS.SUBSCRIPTION_PLAN) {
            return { base: '345px', sm: '700px', md: '800px', lg: '1200px', xl: '1288px' };
        }
    }, [title]);

    return (
        <Box w={calcWeight} {...props}>
            {children}
        </Box>
    );
};

export default AdaptiveContainer;
